import { render, staticRenderFns } from "./behaviorTagretAdd.vue?vue&type=template&id=1434def4&"
import script from "./behaviorTagretAdd.vue?vue&type=script&lang=js&"
export * from "./behaviorTagretAdd.vue?vue&type=script&lang=js&"
import style0 from "./behaviorTagretAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports